/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RouteEntryMethod } from './RouteEntryMethod';
import {
    RouteEntryMethodFromJSON,
    RouteEntryMethodFromJSONTyped,
    RouteEntryMethodToJSON,
    RouteEntryMethodToJSONTyped,
} from './RouteEntryMethod';

/**
 * 
 * @export
 * @interface TrackRouteArrivalRequest
 */
export interface TrackRouteArrivalRequest {
    /**
     * The matched route PATTERN, e.g. "/drop-in/:slug". Groups every visit to that page.
     * @type {string}
     * @memberof TrackRouteArrivalRequest
     */
    route: string;
    /**
     * The resolved path as visited, e.g. "/drop-in/some-creator".
     * @type {string}
     * @memberof TrackRouteArrivalRequest
     */
    path: string;
    /**
     * 
     * @type {RouteEntryMethod}
     * @memberof TrackRouteArrivalRequest
     */
    entryMethod: RouteEntryMethod;
    /**
     * document.referrer on first paint. Omitted for in-app navigations.
     * @type {string}
     * @memberof TrackRouteArrivalRequest
     */
    referrer?: string;
    /**
     * Frontend-generated per-session UUID for journey stitching.
     * @type {string}
     * @memberof TrackRouteArrivalRequest
     */
    sessionId?: string;
    /**
     * Slot id of a hub or Drop section that scrolled into view, e.g. "leaderboard". Present turns this into a section_view row instead of an arrival, so one table answers both "who landed" and "who got far enough to see this".
     * @type {string}
     * @memberof TrackRouteArrivalRequest
     */
    section?: string;
}



/**
 * Check if a given object implements the TrackRouteArrivalRequest interface.
 */
export function instanceOfTrackRouteArrivalRequest(value: object): value is TrackRouteArrivalRequest {
    if (!('route' in value) || value['route'] === undefined) return false;
    if (!('path' in value) || value['path'] === undefined) return false;
    if (!('entryMethod' in value) || value['entryMethod'] === undefined) return false;
    return true;
}

export function TrackRouteArrivalRequestFromJSON(json: any): TrackRouteArrivalRequest {
    return TrackRouteArrivalRequestFromJSONTyped(json, false);
}

export function TrackRouteArrivalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackRouteArrivalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'route': json['route'],
        'path': json['path'],
        'entryMethod': RouteEntryMethodFromJSON(json['entryMethod']),
        'referrer': json['referrer'] == null ? undefined : json['referrer'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'section': json['section'] == null ? undefined : json['section'],
    };
}

export function TrackRouteArrivalRequestToJSON(json: any): TrackRouteArrivalRequest {
    return TrackRouteArrivalRequestToJSONTyped(json, false);
}

export function TrackRouteArrivalRequestToJSONTyped(value?: TrackRouteArrivalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'route': value['route'],
        'path': value['path'],
        'entryMethod': RouteEntryMethodToJSON(value['entryMethod']),
        'referrer': value['referrer'],
        'sessionId': value['sessionId'],
        'section': value['section'],
    };
}

